// eslint-disable-next-line no-multi-assign
const routes = (module.exports = require("next-routes")());

routes
    .add({pattern: "/", page: "index"})
    .add({pattern: "/news", page: "news"})
    .add({pattern: "/news/:id", page: "newsDetails"})
    .add({pattern: "/products/:id", page: "products"})
    .add({pattern: "/product/:id", page: "product"})
    .add({pattern: "/products", page: "products"})
    .add({pattern: "/category/:id", page: "category"})
    .add({pattern: "/categories", page: "category"})
    .add({pattern: "/about", page: "aboutUs"})
    .add({pattern: "/address", page: "address"})
    .add({pattern: "/delivery", page: "delivery"})
    .add({pattern: "/contacts", page: "contacts"})
    .add({pattern: "/profile", page: "profile"})
    .add({pattern: "/cart", page: "cart"})
    .add({pattern: "/favorites", page: "favorites"})
    .add({pattern: "/myOrders", page: "orders"})
    .add({pattern: "/subscription", page: "subscription"})
    .add({pattern: "/viewed", page: "viewedProducts"})
    .add({pattern: "/checkout", page: "checkout"})
    .add({pattern: "/aboutUs", page: "aboutUs"})
    .add({pattern: "/terms-of-use", page: "termsOfUse"})
    .add({pattern: "/privacy-policy", page: "privacyPolicy"})
    .add({pattern: "/return-policy", page: "returnPolicy"})
    .add({pattern: "/faq", page: "faq"})
    .add({pattern: "/auth/login", page: "login"})
    .add({pattern: "/reset-password", page: "resetPassword"})
    .add({pattern: "/auth/registration", page: "registration"})
    .add({pattern: "/confirmation", page: "confirmation"});
